import React from "react";
import Card from "../Asignartecnico/Card";
import styles from "./CardsContainer.module.css";
import { FaInbox } from "react-icons/fa";

export default function CardContainer({ asignartec }) {
  if (!asignartec || !Array.isArray(asignartec) || asignartec.length === 0) {
    return (
      <div className={styles.emptyState}>
        <FaInbox className={styles.emptyIcon} />
        <h3 className={styles.emptyTitle}>Sin tickets por asignar</h3>
        <p className={styles.emptySubtitle}>No hay solicitudes de TI pendientes de técnicos en este momento.</p>
      </div>
    );
  }

  const getEstadoName = (EstadoId) => {
    switch (EstadoId) {
      case 1: return "Creado";
      case 2: return "Asignado y en proceso";
      case 3: return "Pendiente";
      default: return "Desconocido";
    }
  };

  const filteredTickets = asignartec.reduce((acc, ticket) => {
    if (!acc[ticket.TicketId] || new Date(ticket.fecha) > new Date(acc[ticket.TicketId].fecha)) {
      acc[ticket.TicketId] = {
        ...ticket,
        Estado: getEstadoName(ticket.EstadoId)
      };
    }
    return acc;
  }, {});

  const ticketArray = Object.values(filteredTickets).sort((a, b) => new Date(b.fecha) - new Date(a.fecha));

  return (
    <div className={styles.container}>
      {ticketArray.map((ticketData) => (
        <Card
          key={ticketData.TicketId}
          ticketData={ticketData}
          equipoCod={ticketData.Tecniconombre}
          email={ticketData.email}
        />
      ))}
    </div>
  );
}
